<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="border-radius:8px;margin-top:-15px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Child Academic Plan</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p><v-icon color="error">*</v-icon><b>Child</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="child" :items="child_list"
                            item-text="learner" item-value="uid" label="Child" outlined persistent-hint
                            hint="Please Select Child" />
                    </v-col>
                    <v-col col="12" sm="2" md="2" class="pt-6 mt-6" v-if="this.ay && this.child">
                        <v-btn color="brand onBrand--text" @click="fetchAcademicPlan()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{this.academic_planning_list}} -->
            <v-card class="box" v-if="show_child_details_card">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Child Details</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p><b>Student Name</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.name" readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Standard</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.standard"
                            readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Division</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.division"
                            readonly></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><b>Roll No</b></p>
                        <v-text-field outlined dense type="text" v-model="child_details.roll_no"
                            readonly></v-text-field>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="renderComponent">
                <child-calendar v-if="renderComponent"></child-calendar>
            </v-card>
        </v-container>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Academic Calendar Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/jp9PLcgFT68?si=DiRpz3oI16h-eNQj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import child_calendar from "./ChildCalendar.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

    export default {
        components: {
            "child-calendar": child_calendar,
            Breadcrumbs
        },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            videoDialog:false,
            color: "",
            snackbar: false,
            // extraBreadcrumbItems: [
                

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            overlay: false,
            ay_list: [],
            ay: "",
            child_list: [],
            child: "",
            academic_planning_list: [],
            show_child_details_card: false,
            renderComponent: false,
            child_details: { name: "", stamdard: "", division: "", roll_no: "" },
            headers: [
                { text: "Title", value: "title" },
                { text: "Description", value: "description" },
            ],
        }),
        methods: {
            fetchAcademicPlan() {
                const data = {
                    ay: this.ay,
                    child: this.child,
                };
                localStorage.setItem("ay", JSON.stringify(this.ay));
                localStorage.setItem("child", JSON.stringify(this.child));

                this.show_child_details_card = false;
                this.renderComponent = false;
                this.overlay = true;
                axios
                    .post("/AcademicPlanner/getChildAcademicPlans", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_planning_list = res.data.planning_list;
                            this.child_details.name = res.data.learner;
                            this.child_details.standard = res.data.standard;
                            this.child_details.division = res.data.division;
                            this.child_details.roll_no = res.data.roll_no;
                            this.show_child_details_card = true;
                            this.renderComponent = true;
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        //  this.onerror(error);

                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        // this.selected_date=""
                    });
            },
            onLoad() {
                axios
                    .post("ParentTransport/applyTransportFacility")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
                            this.child_list = res.data.learner_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
            this.show_child_details_card = false;
        },
        watch: {},
    };
</script>
<style scoped></style>
